import { createSelector } from 'reselect';
import { selectTabReadings } from './readings';
import { selectCommentPatternToExclude } from './maps';
import { filterCommentText } from '../reducers/utils/mapComments';
import { selectSliceCisview } from './HELPERS';
import { selectGlobalTimeuuid } from './globalData';

export const selectStationAlignment = createSelector(
	selectSliceCisview,
	({ stationAlignment }) => {
		return stationAlignment;
	}
);

const selectOptionsByStationAlignmentType = createSelector(
	selectStationAlignment,
	({ optionsByStationAlignmentType }) => optionsByStationAlignmentType
);

export const selectStatic = createSelector(
	selectOptionsByStationAlignmentType,
	({ static: _static }) => _static
);

const selectEditable = createSelector(
	selectOptionsByStationAlignmentType,
	({ editable }) => editable
);

const selectAlignmentMapSelected = createSelector(
	[selectStationAlignment],
	({ mapSelected }) => {
		return mapSelected;
	}
);

const selectTableType = (state, { tableType }) => {
	return tableType;
};

export const selectMapSelected = createSelector(
	[selectTableType, selectAlignmentMapSelected],
	(tableType, mapSelected) => {
		return mapSelected[tableType];
	}
);

const selectCleanedComment = createSelector(
	[selectTabReadings, selectMapSelected, selectCommentPatternToExclude],
	(tabReadings, mapSelected, commentPatternToExclude) => {
		if (!tabReadings) {
			return '';
		}
		if (!mapSelected) {
			return '';
		}

		const { index } = mapSelected;
		const reading = tabReadings[index];
		if (reading === undefined) {
			return '';
		}
		const { comments } = reading;
		return filterCommentText(comments, commentPatternToExclude);
	}
);

// eslint-disable-next-line import/prefer-default-export
export const selectComment = (state, props) => {
	const mapSelected = selectMapSelected(state, props);
	if (mapSelected === undefined) {
		return undefined;
	}
	const { surveyType, timeuuid } = mapSelected;
	return selectCleanedComment(state, {
		...props,
		dat: { surveyType, timeuuid }
	});
};

export const selectStaticTimeuuid = createSelector(
	[selectStatic],
	({ timeuuid }) => timeuuid
);

export const selectStaticIsLinked = createSelector(
	[selectStatic],
	({ isLinked }) => isLinked
);

export const selectAdditionalSurveys = state => {
	const stateCisview = selectSliceCisview(state);
	const { additionalSurveys: { surveys } = {} } = stateCisview;
	return surveys;
};

const selectAdditionalSurveysConvertedReadings = state => {
	const stateCisview = selectSliceCisview(state);
	const {
		additionalSurveys: { convertedReadingsByTimeuuid } = {}
	} = stateCisview;
	return convertedReadingsByTimeuuid;
};

export const selectOtherAdditionalSurveys = createSelector(
	selectGlobalTimeuuid,
	selectAdditionalSurveys,
	(blockTimeuuid, surveys) => {
		if (!surveys) {
			return undefined;
		}
		return surveys.filter(s => s.timeuuid !== blockTimeuuid);
	}
);

export const selectStaticSurveyReadings = createSelector(
	selectAdditionalSurveysConvertedReadings,
	selectStatic,
	(readings, { timeuuid } = {}) => {
		if (!readings || !timeuuid) {
			return undefined;
		}
		return readings[timeuuid];
	}
);

export const selectEditableSurveyReadings = createSelector(
	selectAdditionalSurveysConvertedReadings,
	selectEditable,
	(readings, { timeuuid } = {}) => {
		if (!readings || !timeuuid) {
			return undefined;
		}
		return readings[timeuuid];
	}
);

export const selectStaticSelectedSurvey = createSelector(
	selectAdditionalSurveys,
	selectStatic,
	(surveys, { timeuuid } = {}) => {
		if (!surveys || !timeuuid) {
			return undefined;
		}
		return surveys.find(s => s.timeuuid === timeuuid);
	}
);
export const selectEditableSelectedSurvey = createSelector(
	selectAdditionalSurveys,
	selectEditable,
	(surveys, { timeuuid } = {}) => {
		if (!surveys || !timeuuid) {
			return undefined;
		}
		return surveys.find(s => s.timeuuid === timeuuid);
	}
);
